import { z } from 'zod';
import { defineListQuery, listFilter } from './list-query.schemas';

/** How recently a truck's tracker has reported, against how often it should (gitaumoses4/chukua#86). */
export const TRACKER_HEALTH_STATUSES = ['healthy', 'late', 'silent'] as const;
export type TrackerHealthStatus = (typeof TRACKER_HEALTH_STATUSES)[number];

/** `status` sorts by how many intervals have passed since the last event, so descending puts the quietest trackers first. */
export const trackerHealthListQuerySchema = defineListQuery({
  sortFields: ['lastEventAt', 'deviceId', 'status'],
  defaultSort: { sort: 'status', order: 'desc' },
  filters: {
    status: listFilter(z.enum(TRACKER_HEALTH_STATUSES)),
    integrationId: listFilter(z.uuid()),
  },
});
export type TrackerHealthListQuery = z.infer<typeof trackerHealthListQuerySchema>;

/**
 * Devices an installation has heard from, for the truck form's picker (gitaumoses4/chukua#422). A device on a truck is left out,
 * except on `forTruckId`'s own, so the truck being edited still sees the device it carries.
 */
export const reportingDeviceListQuerySchema = defineListQuery({
  sortFields: ['deviceId', 'lastHeardAt'],
  defaultSort: { sort: 'lastHeardAt', order: 'desc' },
  filters: {
    integrationId: listFilter(z.uuid()),
    forTruckId: z.uuid().optional(),
  },
});
export type ReportingDeviceListQuery = z.infer<typeof reportingDeviceListQuerySchema>;

export interface ReportingDevice {
  integrationId: string;
  integrationName: string;
  deviceId: string;
  lastHeardAt: string;
}
